import type { TModule } from '@modules/core/types';

import { BATCH_PROCESSING_ROUTE_PATHS } from './config';
import { BATCH_PROCESSING_ROUTES } from './index';

const batchProcessingModule: TModule = {
  id: 'batch-processing',
  fallbackRoute: [BATCH_PROCESSING_ROUTE_PATHS.batchProcessing],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...BATCH_PROCESSING_ROUTES],
};

export { BATCH_PROCESSING_ROUTE_PATHS as BatchProcessingRoutePaths };

export default batchProcessingModule;
